import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Components
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import Main from "./TreasuryDocuments/Main";
import FormAdjust from "./TreasuryDocuments/FormAdjust";
import FormTransfer from "./TreasuryDocuments/FormTransfer";
import FormWDP from "./TreasuryDocuments/FormWDP";

// Utils
import {
  getDataWithComp,
  getAlert,
  getMaxAdjNo,
  getMaxTnsNo,
  getMaxWDPNo,
} from "../../../utils/SamuiUtils";

const TreasuryDocuments = () => {
  const navigate = useNavigate();
  const [mode, setMode] = useState("");
  console.debug("TreasuryDocuments mode", mode);
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataDetailList, setDataDetailList] = useState([]);
  const [maxAdjNo, setMaxAdjNo] = useState();
  const [maxTnsNo, setMaxTnsNo] = useState();
  const [maxWDPNo, setMaxWDPNo] = useState();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      const openForm = localStorage.getItem("TreasuryDocumentsMode");
      if (openForm === "FA" || openForm === "FT" || openForm === "WDP") {
        localStorage.removeItem("TreasuryDocumentsMode");
        setMode(openForm);
      } else {
        setMode("S");
      }
      fetchRealtime(); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp(
        "API_1001_WHDOC_H",
        "ORDER BY WHDoc_No DESC"
      );
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }

      const detailList = await getDataWithComp(
        "API_1002_WHDOC_D",
        "ORDER BY Line ASC"
      );
      if (detailList && detailList.length > 0) {
        setDataDetailList(detailList);
      }

      // หาค่าสูงของ WHDocNo ใน WHDOC_H สำหรับ ADJ (ปรับ) & TN (โอน)
      const findMaxAdjNo = await getDataWithComp(
        "WHDoc_H",
        `AND WHDoc_Type = '1' ORDER BY WHDoc_No DESC`
      );
      const maxAdj = getMaxAdjNo(findMaxAdjNo);

      const findMaxTnsNo = await getDataWithComp(
        "WHDoc_H",
        `AND WHDoc_Type = '2' ORDER BY WHDoc_No DESC`
      );
      const maxTns = getMaxTnsNo(findMaxTnsNo);

      const findMaxWDPNo = await getDataWithComp(
        "WHDoc_H",
        `AND WHDoc_Type = '3' ORDER BY WHDoc_No DESC`
      );
      const MaxWDP = getMaxWDPNo(findMaxWDPNo, "WDR");
      setMaxAdjNo(maxAdj);
      setMaxTnsNo(maxTns);
      setMaxWDPNo(MaxWDP);
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onChangeMode = (mode) => {
    console.debug("onChangeMode", mode);
    localStorage.setItem("TreasuryDocumentsMode", mode);
    setMode(mode);
  };

  const breadcrumbs = [
    { label: "คลังสินค้า", link: "/warehouse" },
    { label: "เอกสารงานคลัง", link: "/treasury-documents" },
  ];

  return (
    <div>
      <div className="TreasuryDocuments">
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="btn btn-toggle-sidebar"
          style={{
            position: "fixed",
            top: "1rem",
            left: isSidebarOpen ? "190px" : "-15px",
            zIndex: 1001,
            background: "transparent",
            border: "none",
            color: "#E13F57",
            fontSize: "20px",
          }}
        >
          {isSidebarOpen ? "✖" : "☰"}
        </button>
        <div className="wrapper">
          <Sidebar
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
          />
          <div
            className={`main-panel ${
              isSidebarOpen ? "sidebar-open" : "sidebar-closed"
            }`}
          >
            <Topbar breadcrumbs={breadcrumbs} />
            <div className="container">
              <div className="page-inner" style={{ marginTop: "56px" }}>
                {mode === "S" && (
                  <Main
                    name={"เอกสารงานคลัง"}
                    onChangeMode={onChangeMode}
                    dataMasterList={dataMasterList}
                    dataDetailList={dataDetailList}
                  />
                )}
                {mode === "FA" && (
                  <FormAdjust
                    callInitialize={initialize}
                    mode={mode}
                    name={"ใบปรับปรุงสินค้า"}
                    whDocNo={maxAdjNo}
                  />
                )}
                {mode === "FT" && (
                  <FormTransfer
                    callInitialize={initialize}
                    mode={mode}
                    name={"ใบโอนย้ายสินค้า"}
                    whDocNo={maxTnsNo}
                  />
                )}
                {mode === "WDP" && (
                  <FormWDP
                    callInitialize={initialize}
                    mode={mode}
                    name={"ใบเบิกสินค้า"}
                    whDocNo={maxWDPNo}
                    docNoPrefix="WDR"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TreasuryDocuments;
